import React, { ChangeEvent } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { LabelValueSet } from "../../../domain/utility/LabelValueSet";

export function FilterButton(props: FilterButtonProps) {
    const {
        filterOpen,
        handleFilter,
        openIconPath,
        filterConditions,
        currentConditions,
        handleFilterChanged,
    } = props;

    const isMatchedFilter = (filterValue: string) => currentConditions.includes(filterValue);

    const closefilterDialog = () => handleFilter(false);

    return (
        <>
            <button className={"icon_button"} onClick={() => handleFilter(!filterOpen)}>
                <img src={openIconPath} alt="" />
            </button>
            <OutsideClickHandler onOutsideClick={closefilterDialog}>
                <div className={"filter_container"} style={{ display: filterOpen ? "" : "none" }}>
                    <div className={"filter_content"}>
                        {/* タイトル */}
                        <div className={"filter_title"}>フィルター</div>
                        {/* 閉じるボタン */}
                        <button
                            className={"close_button"}
                            onClick={closefilterDialog}
                        >
                            <img src={"/images/icon_close.svg"} alt="" />
                        </button>
                        {/* チェックボックス */}
                        {filterConditions.map((it) => {
                            return (
                                <label key={it.label} className={"check_box"}>
                                    <input type="checkbox" value={it.value} checked={isMatchedFilter(it.value)} onChange={handleFilterChanged} />
                                    <span className="icon_checked" />
                                    {it.label}
                                </label>
                            );
                        })}
                    </div>
                </div>
            </OutsideClickHandler>
        </>

    );
}

export type FilterButtonProps = {
    filterOpen: boolean,
    handleFilter: (filterOpen: boolean) => void,
    openIconPath: string,
    filterConditions: LabelValueSet[],
    currentConditions: string[],
    handleFilterChanged: (event: ChangeEvent<HTMLInputElement>) => void,
};
